{
  "aboutToExpire": "(about to expire)",
  "upgrade": "Upgrade Plan",
  "trialActive": "Trial active",
  "trialExpired": "Trial expired",
  "allOrgs": "All Organizations",
  "desc": "Join, leave, or create an organization.",
  "pendingOrgSetup": "Looks like you have one or more organizations that still need setup. You’ll need to finish setting them up before you can create a new one.",
  "noResultsTitle": "No Results Found",
  "noResultsMessage": "The filters returned no results.",
  "searchOrgs": "Search organizations by ID or name",
  "switchOrganizations": "Switch Organization",
  "allOrganizations": "All Organizations",
  "enterpriseDashboard": "Enterprise Dashboard",
  "setDefaultOrganizationError": "Unable to set default organization at the moment.",
  "makeDefault": "Make default",
  "defaultOrganization": "Default organization",
  "pendingSetup": "Pending setup",
  "ownedBy": "Owned by {{ owner }}",
  "leaveConfirmation": "Do you really want to leave this organization?",
  "leave": "Leave",
  "manage": "Manage",
  "continueSetup": "Continue setup",
  "join": "Join",
  "requestJoin": "Request to join",
  "createOrg": "Create a new organization",
  "gm": "GM",
  "member": "Member",
  "admin": "Admin",
  "owner": "Owner",
  "superadmin": "Super Admin",
  "readonly": "Read-Only",
  "findOrganization": "Find an organization",
  "noResults": "No organizations were found"
}
